import { render, staticRenderFns } from "./PcRep.vue?vue&type=template&id=4053cd2b&scoped=true&"
import script from "./PcRep.vue?vue&type=script&lang=js&"
export * from "./PcRep.vue?vue&type=script&lang=js&"
import style0 from "./PcRep.vue?vue&type=style&index=0&id=4053cd2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4053cd2b",
  null
  
)

export default component.exports